import * as React from 'react';
import {
  useWorkspaceResolver,
  type ResolvedFile,
} from './WorkspaceResolverContext';

type PresentationSyncContextValue = {
  resolvedFile: ResolvedFile | null;
  documentUrl: string | null;
};

const PresentationSyncContext =
  React.createContext<PresentationSyncContextValue>({
    resolvedFile: null,
    documentUrl: null,
  });

export function PresentationSyncProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { resolvedFile, documentUrl } = useWorkspaceResolver();

  const value = React.useMemo(
    () => ({ resolvedFile, documentUrl }),
    [resolvedFile, documentUrl]
  );

  return (
    <PresentationSyncContext.Provider value={value}>
      {children}
    </PresentationSyncContext.Provider>
  );
}

export function usePresentationSync() {
  return React.useContext(PresentationSyncContext);
}
